var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rk-table__resize",staticStyle:{"width":"5px"},attrs:{"data-name":"resize"},on:{"mousedown":_vm.mousedown}})
}
var staticRenderFns = []

export { render, staticRenderFns }